module.exports = __webpack_public_path__ + "static/media/star.377d54b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/star.svg
// module id = 1399
// module chunks = 0